import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ArchivedListComponentComponent } from './archived-list-component.component';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';

const routes: Routes = [
  {
          path: '',
          component: ArchivedListComponentComponent,
          data: { title: 'Applications Master', componentName: 'app-application-master-list' }
        },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArchivedListRoutingModule { }
